import React from 'react'

import {
  Alert,
  AlignItems,
  AppWrapper,
  Columns,
  ComponentColor,
  ComponentSize,
  CTALinkButton,
  FlexBox,
  FlexDirection,
  FontWeight,
  FunnelPage,
  Grid,
  Heading,
  HeadingElement,
  IconFont,
  Panel,
} from '@influxdata/clockface'

import InfluxDataLogo from 'js/components/InfluxDataLogo'

const InviteAccepted = () => {
  return (
    <AppWrapper type="funnel">
      <FunnelPage logo={<InfluxDataLogo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <FlexBox
              direction={FlexDirection.Column}
              alignItems={AlignItems.Center}
            >
              <Heading
                className="invite-accepted--header"
                element={HeadingElement.H3}
                weight={FontWeight.Regular}
              >
                This invitation is no longer valid
              </Heading>
              <div className="invite-accepted--copy-container">
                <Panel.Header size={ComponentSize.Large}>
                  <Alert
                    color={ComponentColor.Danger}
                    icon={IconFont.AlertTriangle}
                  >
                    The invitation you are trying to view has already been
                    accepted
                  </Alert>
                </Panel.Header>
                <Panel className="invite-accepted--panel">
                  <Panel.Body size={ComponentSize.Small}>
                    <p>
                      Please log in to use InfluxDB Cloud. Or contact your
                      organization admin to request a new invite link.
                    </p>
                  </Panel.Body>
                </Panel>
              </div>
              <CTALinkButton
                className="invite-accepted--cta-button"
                color={ComponentColor.Primary}
                text="Continue to Log In"
                href="/login"
              />
              <p>
                Issues?
                <br />
                Talk to{' '}
                <a href="mailto:support@influxdata.com" target="_blank">
                  support@influxdata.com
                </a>
              </p>
            </FlexBox>
          </Grid.Column>
        </Grid.Row>
      </FunnelPage>
    </AppWrapper>
  )
}

export default InviteAccepted
